import * as types from './types'

const initialState = {
	id: null,
	body: '',
	expirationDate: null,
	messages: [],
	connected: false,
	isShowing: false,
	isShowingMessage: false,
	welcomeMessage: false,
	notificationsLoaded: false,
	message: null,
	isShowingEditMessage: false,
	scope: 'public',
	selectedOrgGroups: [],
	selectedUsers: [],
	selectedLocationGroups: [],
	selectedLocations: [],
	selectedRoles: [],
	selectedStores: [],
	currentTab: 'category',
	currentItems: 'groupOrgs',
	currentSelectedItems: 'selectedOrgGroups',
	currentToggleFunction: 'toggleOrgGroups',
	assignSearchValue: '',
	showSelectedOrgGroups: false,
	showSelectedUsers: false,
	showSelectedLocationGroups: false,
	showSelectedLocations: false,
	showSelectedStores: false,
	showSelectedRoles: false,
	currentHideSelectedItemsFunction: 'setHideSelectedOrgGroups',
	currentShowSelectedItemsFunction: 'setShowSelectedOrgGroups',
	currentShowSelectedItems: 'showSelectedOrgGroups',
	isReqLoading: false,
	toggleModal: false,
	loading: false,
}

const commboardReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.CONNECTED:
			return {
				...state,
				connected: true,
			}
		case types.MESSAGE:
			return {
				...state,
				messages: action.data,
			}
		case types.TOGGLE_OVERLAY:
			return {
				...state,
				isShowing: action.isShowing,
			}

		case types.TOGGLE_MESSAGE_OVERLAY:
			return {
				...state,
				isShowingMessage: action.isShowingMessage,
				message: action.message,
			}

		case types.ON_CHANGE:
			return {
				...state,
				[action.name]: action.value,
			}
		case types.LOADING:
			return {
				...state,
				[action.loadingType]: action.isLoading,
			}
		case types.EXPIRATION_DATE:
			return {
				...state,
				expirationDate: action.date,
			}
		case types.MARK_AS_WELCOME:
			return {
				...state,
				welcomeMessage: action.welcomeMessage,
			}
		case types.TOGGLE_EDIT_MESSAGE_OVERLAY:
			return {
				...state,
				isShowingEditMessage: action.isShowingEditMessage,
				id: action.id,
				message: action.message,
				expirationDate: action.expirationDate,
			}
		case types.ON_CHANGE_MESSAGE:
			return {
				...state,
				message: action.message,
			}
		case types.SET_FILE_SCOPE:
			return {
				...state,
				scope: action.value,
			}
		case types.SET_CURRENT_TAB:
			return {
				...state,
				currentTab: action.currentTab,
			}
		case types.SET_SELECTED_ORG_GROUPS:
			return {
				...state,
				selectedOrgGroups: action.orgGroups,
			}
		case types.SET_CURRENT_SELECTED_ITEMS:
			return {
				...state,
				currentSelectedItems: action.currentSelectedItems,
			}
		case types.SET_CURRENT_ITEMS:
			return {
				...state,
				currentItems: action.currentItems,
			}
		case types.SET_CURRENT_TOGGLE_ITEM_FUNCTION:
			return {
				...state,
				currentToggleFunction: action.currentToggleFunction,
			}
		case types.SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION:
			return {
				...state,
				currentHideSelectedItemsFunction:
					action.currentHideSelectedItemsFunction,
			}
		case types.SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION:
			return {
				...state,
				currentShowSelectedItemsFunction:
					action.currentShowSelectedItemsFunction,
			}
		case types.SET_CURRENT_SHOW_SELECTED_ITEMS:
			return {
				...state,
				currentShowSelectedItems: action.currentShowSelectedItems,
			}
		case types.SET_SELECTED_USERS:
			return {
				...state,
				selectedUsers: action.users,
			}
		case types.SET_SELECTED_LOCATION_GROUPS:
			return {
				...state,
				selectedLocationGroups: action.locationGroups,
			}
		case types.SET_SELECTED_LOCATIONS:
			return {
				...state,
				selectedLocations: action.locations,
			}
		case types.SET_SELECTED_STORES:
			return {
				...state,
				selectedStores: action.stores,
			}
		case types.SET_SELECTED_ROLES:
			return {
				...state,
				selectedRoles: action.roles,
			}
		case types.RESET_SELECTED_ITEMS:
			return {
				...state,
				selectedLocationGroups: [],
				selectedLocations: [],
				selectedStores: [],
				selectedOrgGroups: [],
				selectedRoles: [],
				selectedUsers: [],
			}
		case types.SET_ASSIGN_SEARCH_VALUE:
			return {
				...state,
				assignSearchValue: action.assignSearchValue,
			}
		case types.SET_SHOW_SELECTED_ORG_GROUPS:
			return {
				...state,
				showSelectedOrgGroups: action.showSelectedOrgGroups,
			}
		case types.SET_SHOW_SELECTED_USERS:
			return {
				...state,
				showSelectedUsers: action.showSelectedUsers,
			}
		case types.SET_SHOW_SELECTED_LOCATION_GROUPS:
			return {
				...state,
				showSelectedLocationGroups: action.showSelectedLocationGroups,
			}
		case types.SET_SHOW_SELECTED_LOCATIONS:
			return {
				...state,
				showSelectedLocations: action.showSelectedLocations,
			}
		case types.SET_SHOW_SELECTED_STORES:
			return {
				...state,
				showSelectedStores: action.showSelectedStores,
			}
		case types.SET_SHOW_SELECTED_ROLES:
			return {
				...state,
				showSelectedRoles: action.showSelectedRoles,
			}
		case types.IS_REQ_LOADING:
			return {
				...state,
				isReqLoading: action.isReqLoading,
			}
		case types.TOGGLE_MODAL:
			return { ...state, toggleModal: action.payload }
		case types.LOADED:
			return { ...state, loading: action.payload }
		default:
			return state
	}
}

export default commboardReducer
